import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as reactDom from 'react-dom';
import { IntlProvider } from 'react-intl';

import { DiscreteFieldDefault } from './DiscreteFieldDefault';
import { BirthDateComponent } from '../components/FormFields/BirthDate/BirthDateComponent';

export class BirthdateField extends DiscreteFieldDefault {
    constructor(element: HTMLElement) {
        super(element);
    }

    render() {
        reactDom.render(
            (
                <IntlProvider locale={this.locale} key={this.locale} messages={this.messages}>
                    <BirthDateComponent
                        value={this.value}
                        onChange={(val: any) => this.doChange(val)}
                        isErrored={this.isErrored}
                        errorId={this.errorId}
                    />
                </IntlProvider>
            ),
            this.mountPoint);
    }
}
